// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intro-container {
  display: flex;
  flex-direction: column;
}
.intro-container .intro-header {
  padding-left: 20px;
}
.intro-container .misc-actions-container {
  display: flex;
  padding: 0 15px;
  align-items: center;
  margin-left: auto;
  position: relative;
}
.intro-container .misc-actions-container .input-wrapper .MuiInputBase-root {
  padding: 0px 26px 0px 12px !important;
}
.intro-container .misc-actions-container .intro-cta-btns {
  display: flex;
  flex-direction: row;
  margin-left: auto;
}
.intro-container .intro-description {
  display: flex;
  margin-bottom: 20px;
}
.intro-container .intro-page-content {
  display: flex;
  padding: 30px;
  flex-direction: column;
}

.intro {
  display: flex;
  padding-top: 25px;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  padding: 0 20% 0 20%;
  font-size: 16px;
  margin-bottom: 50px;
}

.carousel-control-next,
.carousel-control-prev {
  width: 8% !important;
}

.carousel-indicators [data-bs-target] {
  width: 10px !important;
  height: 10px !important;
  border-radius: 100%;
}

.icon-sort {
  font-size: 14px;
}

.blocks-container {
  gap: 38px;
}
.blocks-container .app-block {
  min-width: 100% !important;
}

.blocks {
  border-radius: 5px;
  border: 1px solid var(--blocks-border-color) !important;
  background-color: var(--blocks-background-color) !important;
  color: var(--blocks-name-text-color) !important;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2509803922);
  height: 180px;
  margin: 13px;
  width: 90%;
  padding: 15px 15px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  cursor: pointer;
}
.blocks .image-container {
  background-color: var(--blocks-image-background-color) !important;
}

.intro-content {
  margin-top: 30px;
  margin-left: 20px;
  font-size: 14px;
}

.misc-actions-container .icon-sort,
.misc-actions-container .icon-filter,
.misc-actions-container .icon-search {
  color: #666 !important;
  cursor: pointer !important;
  width: 16px !important;
  margin-left: 3px !important;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.confirm-buttons {
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: 25px;
  right: 25px;
  gap: 10px;
}
.confirm-buttons .confirm-cancel-btn {
  width: 70px;
  height: 25px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 20px;
  border: 1px solid #0051ff;
  cursor: pointer;
  font-size: 12px;
}
.confirm-buttons .confirm-yes-btn {
  font-family: "ABBVoice-light";
  font-size: 12px;
  width: 70px;
  height: 25px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 20px;
  background: #36f;
  border: none;
  box-shadow: none;
  color: white;
  cursor: pointer;
}

.modal-popup-box h2 {
  font-size: 14px;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent !important;
  color: var(--input-text-color) !important;
  cursor: pointer;
  border-radius: 50%;
}

.user-preference-container .col-2 .form-group .form-input input {
  font-size: 12px !important;
  padding: 13px 0 12px 15px !important;
  color: var(--input-text-color) !important;
}

.content-container .child-content {
  width: 100%;
  height: calc(100% - 25px);
  overflow: auto;
}

.input-styles {
  color: var(--text-primary-color) !important;
}

.MuiButtonBase-root.MuiMenuItem-root {
  color: var(--drop-down-text-primary-color) !important;
  background-color: var(--drop-down-text-primary-background-color) !important;
  font-size: 0.875rem;
  font-family: "ABBVoice", Verdana;
  font-weight: 400;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: start;
  gap: 8px;
}

.MuiButtonBase-root.MuiMenuItem-root.Mui-selected {
  background-color: var(--accordion-expanded-bg) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/home.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AACE;EACE,kBAAA;AACJ;AAEE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;AAGM;EACE,qCAAA;AADR;AAME;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;AALJ;AAQE;EACE,aAAA;EACA,aAAA;EACA,sBAAA;AANJ;;AAUA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;AAPF;;AAUA;;EAEE,oBAAA;AAPF;;AAUA;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,eAAA;AAPF;;AAUA;EACE,SAAA;AAPF;AASE;EACE,0BAAA;AAPJ;;AAWA;EACE,kBAAA;EAEA,uDAAA;EACA,2DAAA;EACA,+CAAA;EACA,iDAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,eAAA;AATF;AAWE;EACE,iEAAA;AATJ;;AAaA;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;AAVF;;AAaA;;;EAGE,sBAAA;EACA,0BAAA;EACA,sBAAA;EACA,2BAAA;AAVF;;AAaA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AAVF;AAWE;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AATJ;AAWE;EACE,6BAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AATJ;;AAeE;EACE,eAAA;AAZJ;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;AAZF;;AAeA;EACE,0BAAA;EACA,oCAAA;EAEA,yCAAA;AAbF;;AAgBA;EACE,WAAA;EACA,yBAAA;EACA,cAAA;AAbF;;AAgBA;EACE,2CAAA;AAbF;;AAgBA;EACE,qDAAA;EACA,2EAAA;EACA,mBAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,QAAA;AAbF;;AAgBA;EACE,yDAAA;AAbF","sourcesContent":[".intro-container {\n  display: flex;\n  flex-direction: column;\n\n  .intro-header {\n    padding-left: 20px;\n  }\n\n  .misc-actions-container {\n    display: flex;\n    padding: 0 15px;\n    align-items: center;\n    margin-left: auto;\n    position: relative;\n\n    .input-wrapper {\n      .MuiInputBase-root {\n        padding: 0px 26px 0px 12px !important;\n      }\n    }\n  }\n\n  .misc-actions-container .intro-cta-btns {\n    display: flex;\n    flex-direction: row;\n    margin-left: auto;\n  }\n\n  .intro-description {\n    display: flex;\n    margin-bottom: 20px;\n  }\n\n  .intro-page-content {\n    display: flex;\n    padding: 30px;\n    flex-direction: column;\n  }\n}\n\n.intro {\n  display: flex;\n  padding-top: 25px;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  flex-direction: column;\n  padding: 0 20% 0 20%;\n  font-size: 16px;\n  margin-bottom: 50px;\n}\n\n.carousel-control-next,\n.carousel-control-prev {\n  width: 8% !important;\n}\n\n.carousel-indicators [data-bs-target] {\n  width: 10px !important;\n  height: 10px !important;\n  border-radius: 100%;\n}\n\n.icon-sort {\n  font-size: 14px;\n}\n\n.blocks-container {\n  gap: 38px;\n\n  .app-block {\n    min-width: 100% !important;\n  }\n}\n\n.blocks {\n  border-radius: 5px;\n  //background: #f5f5f5;\n  border: 1px solid var(--blocks-border-color)!important;\n  background-color: var(--blocks-background-color)!important;\n  color: var(--blocks-name-text-color)!important;\n  box-shadow: 0 4px 4px #00000040;\n  height: 180px;\n  margin: 13px;\n  width: 90%;\n  padding: 15px 15px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  cursor: pointer;\n\n  .image-container {\n    background-color: var(--blocks-image-background-color)!important;\n  }\n}\n\n.intro-content {\n  margin-top: 30px;\n  margin-left: 20px;\n  font-size: 14px;\n}\n\n.misc-actions-container .icon-sort,\n.misc-actions-container .icon-filter,\n.misc-actions-container .icon-search {\n  color: #666 !important;\n  cursor: pointer !important;\n  width: 16px !important;\n  margin-left: 3px !important;\n}\n\n.loader-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.confirm-buttons {\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  bottom: 25px;\n  right: 25px;\n  gap: 10px;\n  .confirm-cancel-btn {\n    width: 70px;\n    height: 25px;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    border-radius: 20px;\n    border: 1px solid #0051ff;\n    cursor: pointer;\n    font-size: 12px;\n  }\n  .confirm-yes-btn {\n    font-family: \"ABBVoice-light\";\n    font-size: 12px;\n    width: 70px;\n    height: 25px;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    border-radius: 20px;\n    background: #36f;\n    border: none;\n    box-shadow: none;\n    color: white;\n    cursor: pointer;\n  }\n}\n\n\n.modal-popup-box {\n  h2 {\n    font-size: 14px;\n  }\n}\n.icon-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent !important;\n  color: var(--input-text-color)!important;\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n.user-preference-container .col-2 .form-group .form-input input {\n  font-size: 12px !important;\n  padding: 13px 0 12px 15px !important;\n  //color: white!important;\n  color: var(--input-text-color)!important;\n}\n\n.content-container .child-content {\n  width: 100%;\n  height: calc(100% - 25px);\n  overflow: auto;\n}\n\n.input-styles {\n  color: var(--text-primary-color) !important;\n}\n\n.MuiButtonBase-root.MuiMenuItem-root {\n  color: var(--drop-down-text-primary-color)!important;\n  background-color: var(--drop-down-text-primary-background-color) !important;\n  font-size: 0.875rem;\n  font-family: \"ABBVoice\", Verdana;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  justify-content: start;\n  gap: 8px;\n}\n\n.MuiButtonBase-root.MuiMenuItem-root.Mui-selected {\n  background-color: var(--accordion-expanded-bg) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
